export default {
  /**
   * Global loading flag (for UI components)
   * @return {boolean}
   */
  isLoading: state => {
    return !!state.requestCounter;
  },

  /**
   * Global Full-page preloader flag
   * @return {boolean}
   */
  useFullPagePreloader: (state, getters) => {
    return getters.isLoading && state.useFullPagePreloader;
  }
};
